import { Inject, Injectable, OnDestroy } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { TableService } from "src/app/_metronic/shared/crud-table";
import { environment } from "src/environments/environment";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Product } from "../models/product.model";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class ProductsService
  extends TableService<Product>
  implements OnDestroy
{
  BASE_URL = environment.apiUrl;
  GET_ALL_URL = "Product";
  CREATE_URL = "Product";
  GET_ONE_URL = "Product";
  UPDATE_URL = "Product";
  DELETE_URL = "Product";

  constructor(
    @Inject(HttpClient) http,
    router: Router,
    activatedRoute: ActivatedRoute
  ) {
    super(http, router, activatedRoute);
  }
  hide(id): Observable<any> {
    return this.http.put(`${this.BASE_URL}/Product/Hide/${id}`, null);
  }

  unhide(id): Observable<any> {
    return this.http.put(`${this.BASE_URL}/Product/UnHide/${id}`, null);
  }

  getProductTypes(id): Observable<any> {
    return this.http.get(`${this.BASE_URL}/Product/GetProductTypes/${id}`);
  }

  getPriceByCurrency(productId: number, currencyCode: string) {
    return this.http.get(`${this.BASE_URL}/${this.GET_ONE_URL}/${productId}`, {
      headers: new HttpHeaders().set("Currency", currencyCode),
    });
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sb) => sb.unsubscribe());
  }
}
